import * as React from 'react'
import {Dialog, DialogDismiss, DialogHeading} from '@ariakit/react'
import * as dialogStyles from '@frontrow/console/src/components/dialog/dialog.module.scss'
import {Label} from '@frontrow/console/src/components/ui/label'
import {Button} from '@frontrow/console/src/components/button'

import * as style from './delete-license-button-modal.module.scss'
import {useModalForm} from '@frontrow/console/src/hooks/use-modal-form'

type Props = {
  schoolName: string
  startDateDetail: string
  endDateDetail: string
  subjectDetail: string
  removeLicense: () => void
  enableModifications: boolean
}

function DeleteLicenseButtonModal(props: Props): React.ReactElement {
  const {
    schoolName,
    startDateDetail,
    endDateDetail,
    subjectDetail,
    removeLicense,
    enableModifications
  } = props

  const {isOpen, open, close} = useModalForm()

  const handleRemoveLicense = () => {
    removeLicense()
    close()
  }

  return (
    <React.Fragment>
      <Button style="link" onClick={open} disabled={!enableModifications}>
        <i className="fa fa-trash fa-lg" />
      </Button>
      <Dialog
        open={isOpen}
        onClose={close}
        backdrop={<div className={dialogStyles.backdrop} />}
        className={dialogStyles.dialog}
        portal
        unmountOnHide
        hideOnEscape
        hideOnInteractOutside={false}
      >
        <div className={dialogStyles.header}>
          <DialogHeading className={dialogStyles.title}>
            Delete License on {schoolName}
          </DialogHeading>
          <DialogDismiss className={dialogStyles.closeButton}>
            <span aria-hidden="true">&times;</span>
          </DialogDismiss>
        </div>
        <div className={dialogStyles.body}>
          <Label addClass={style.schoolNameLabel}>{schoolName}</Label>
          <div className={style.deleteLicenseDetailContainer}>
            <div className={style.deleteLicenseDetail}>{startDateDetail}</div>
            <div className={style.deleteLicenseDetail}>{endDateDetail}</div>
            <div className={style.deleteLicenseDetail}>{subjectDetail}</div>
          </div>
        </div>
        <div className={style.deleteLicenseButtonContainer}>
          <Button style="link" addClass={style.deleteLicenseButton} onClick={close}>
            Cancel
          </Button>
          <Button style="danger" addClass={style.deleteLicenseButton} onClick={handleRemoveLicense}>
            Delete License
          </Button>
        </div>
      </Dialog>
    </React.Fragment>
  )
}

export default DeleteLicenseButtonModal
